module.exports = __webpack_public_path__ + "img/team.cf849265.svg";